import { render, staticRenderFns } from "./RiskScorePercentage.vue?vue&type=template&id=ffaaca0c&scoped=true"
import script from "./RiskScorePercentage.vue?vue&type=script&lang=js"
export * from "./RiskScorePercentage.vue?vue&type=script&lang=js"
import style0 from "./RiskScorePercentage.vue?vue&type=style&index=0&id=ffaaca0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffaaca0c",
  null
  
)

export default component.exports